<template>
  <component
    :is="membershipMode ? 'button' : 'a'"
    :href="membershipMode ? undefined : chatUrl"
    type="button"
    class="chat-list-row"
    :class="{'chat-list-row--highlighted': highlighted, 'chat-list-row--membership': membershipMode}"
    @click.prevent="membershipMode ? $emit('toggle') : $emit('open')"
  >
    <span v-if="membershipMode" class="chat-list-row__check" :class="{'chat-list-row__check--selected': selected}" aria-hidden="true"><i class="fas fa-check"></i></span>
    <img class="chat-list-row__icon" :src="chat.icon_path" :alt="chat.nickname">
    <span class="chat-list-row__content">
      <span class="chat-list-row__nickname">{{ chat.nickname }}</span>
      <span v-if="chat.latest_message !== null" class="chat-list-row__message">{{ chat.latest_message }}</span>
    </span>
    <span v-if="chat.latest_message !== null" class="chat-list-row__meta">
      <span class="chat-list-row__time">{{ chat.latest_message_time_label }}</span>
      <span v-if="unreadCountLabel !== null" class="chat-list-row__unread">{{ unreadCountLabel }}</span>
    </span>
  </component>
</template>

<script setup>
import {computed} from 'vue';

defineEmits(['open', 'toggle']);

const props = defineProps({
  chat: {
    type: Object,
    required: true,
  },
  highlighted: {
    type: Boolean,
    default: false,
  },
  chatUrl: {
    type: String,
    required: true,
  },
  membershipMode: {type: Boolean, default: false},
  selected: {type: Boolean, default: false},
});

const unreadCountLabel = computed(() => {
  if (props.chat.unread_count < 1) {
    return null;
  }

  return props.chat.unread_count >= 100 ? '99+' : String(props.chat.unread_count);
});
</script>

<style scoped>
.chat-list-row {
  position: relative;
  display: grid;
  grid-template-columns: 52px minmax(0, 1fr) auto;
  gap: 12px;
  align-items: center;
  min-width: 0;
  min-height: 76px;
  padding: 10px 14px;
  border-bottom: 1px solid #ededf0;
  color: inherit;
  background: #fff;
  text-decoration: none;
  text-align: left;
  border-top: 0;
  border-right: 0;
  border-left: 0;
}

.chat-list-row__check{position:absolute;z-index:1;top:7px;left:8px;display:grid;width:22px;height:22px;border:2px solid #fff;border-radius:50%;color:transparent;background:#c9cbd0;font-size:11px;place-items:center}.chat-list-row__check--selected{color:#fff;background:#f28b22}.chat-list-row--membership{width:100%;cursor:pointer}

.chat-list-row__icon {
  display: block;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  object-fit: cover;
  background: #f1f1f3;
}

.chat-list-row__content,
.chat-list-row__meta {
  display: flex;
  min-width: 0;
  height: 48px;
  flex-direction: column;
}

.chat-list-row__content {
  justify-content: center;
}

.chat-list-row__nickname,
.chat-list-row__message {
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chat-list-row__nickname {
  color: #303036;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.5;
}

.chat-list-row__message {
  margin-top: 2px;
  color: #74747c;
  font-size: 13px;
  line-height: 1.5;
}

.chat-list-row__meta {
  align-items: flex-end;
  justify-content: space-between;
  max-width: 72px;
}

.chat-list-row__time {
  color: #7f7f87;
  font-size: 11px;
  line-height: 1.5;
  white-space: nowrap;
}

.chat-list-row__unread {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  border-radius: 999px;
  color: #fff;
  background: #2dbb69;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
}

.chat-list-row--highlighted {
  animation: chat-list-row-highlight 0.75s ease-out;
}

@keyframes chat-list-row-highlight {
  0%, 35% {
    box-shadow: inset 0 0 0 9999px rgba(45, 187, 105, 0.16);
  }
  100% {
    box-shadow: inset 0 0 0 9999px rgba(45, 187, 105, 0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .chat-list-row--highlighted {
    animation: none;
    box-shadow: inset 0 0 0 9999px rgba(45, 187, 105, 0.12);
  }
}
</style>
